/**
 * @observable
 * Created by neo on 01.06.17.
 */

import {observable} from 'mobx';
import Person from './Person';
import User from './User';
import ContactInfo from './Person/ContactInfo';

export default class Client {
  @observable id: string;
  @observable companyId: string;
  @observable person: Person;
  @observable user: User;
  @observable contactInfo: ContactInfo;

  constructor(json?: any) {
    if(json) {
      this.id = json.id;
      this.companyId = json.companyId;
      this.person = new Person(json.person);
      this.user = new User(json.user);
      this.contactInfo = new ContactInfo(json.contactInfo);
    }
  }
}



// WEBPACK FOOTER //
// ./src/App/Store/Client.js